module.exports = __webpack_public_path__ + "img/r-1-btn.ecab5a1b.png";